import { Link } from "react-router-dom";
import { COMPANY, NAV_LINKS, SERVICES } from "@/lib/company";

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-auto" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-1">
          <div className="text-white font-extrabold tracking-tight text-lg">ANDR BNDT88 TRANS LLC</div>
          <p className="mt-3 text-sm leading-relaxed text-slate-400">
            Florida-based automotive transportation and vehicle services company. Vehicle
            transport, purchasing, resale, and export logistics coordination.
          </p>
        </div>

        <div>
          <div className="text-white text-sm font-semibold uppercase tracking-wide">Pages</div>
          <ul className="mt-3 space-y-2 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="text-slate-400 hover:text-white">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-white text-sm font-semibold uppercase tracking-wide">Services</div>
          <ul className="mt-3 space-y-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.key} className="text-slate-400">{s.title}</li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-white text-sm font-semibold uppercase tracking-wide">Contact</div>
          <address className="mt-3 not-italic text-sm space-y-1 text-slate-400">
            <div>{COMPANY.address_line1}</div>
            <div>{COMPANY.address_line2}</div>
            <div>{COMPANY.country}</div>
            <div className="pt-2">
              <a href={`tel:${COMPANY.phoneHref}`} className="hover:text-white">{COMPANY.phone}</a>
            </div>
            <div>
              <a href={`mailto:${COMPANY.email}`} className="hover:text-white">{COMPANY.email}</a>
            </div>
            <div className="pt-2 text-slate-500">{COMPANY.hours}</div>
          </address>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="mx-auto max-w-7xl px-4 py-5 text-xs text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} ANDR BNDT88 TRANS LLC. All rights reserved.</span>
          <span>Established {COMPANY.established} · Fort Lauderdale, Florida</span>
        </div>
      </div>
    </footer>
  );
};
